import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import { Link } from 'react-router'

import hiResLogo from '../../resources/img/logo-hires.png'
import TrackList from '../../components/tracklist/TrackList'
import redirectToApp from '../../utils/redirectToApp'

import { getTrack as getTrackAction } from './trackActions'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as selectors from './trackSelectors'
import Loader from '../../components/loader/Loader'
import appConst from '../../constant/appConst'
import { Helmet } from 'react-helmet'

const fields = [{
	type: 'number',
	render: () => 1
},{
	type: 'name',
	render: track => track.title
},{
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

class TrackPage extends PureComponent {

	componentWillMount() {
		const { getTrack, id } = this.props
		getTrack(id)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) this.props.clearPlayqueue()
	}

	render() {
		const { id, title, album, artist, performer, duree, isHiRes, orderUrl } = this.props
		const { intl } = this.context

		let dureeAffichee
		if (duree > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duree/3600)}`, minutes: `${Math.floor((duree % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duree/60)}`, seconds: `${duree % 60}` }
			)
		}

		let artistData = null
		if (performer) {
			artistData = performer
		} else if (artist) {
			artistData = artist
		}

		return (
			<Loader>
				<div className="content mt40">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.track" }, { trackName: title, artistName: artist.name })}</title>
					</Helmet>
					<div className="album-background" style={{ backgroundImage: `url(${album.pochette})` }} />
					<div className="album-background-overlay" />
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="album-cover-content">
									<img className="album-cover" src={album.pochette} alt={album.title} />
									{isHiRes && <span className="hi-res-quality">
										<img src={hiResLogo} alt={intl.formatMessage({ id: 'infos.hires' })} height={30} width={30} />
									</span>}
								</div>
								<div className="text-center mb50">
									<h1 className="t4 text-bold mb10">{title}</h1>
									{artistData && <p className="t2 mb10"><Link to={`/artist/${artistData.id}`}>{artistData.name}</Link></p>}
									<p className="t6 mb10"><Link to={`/album/${album.id}`}>{album.title}</Link></p>
									<p className="c2 mb20"><span className="pct pct-circle-wait ml10" /> {dureeAffichee}</p>
									<a onClick={() => redirectToApp('track', id)} className="bt7">{intl.formatMessage({ id: 'buttons.listen' })}</a>
									<p className="mt10 t5">
										{orderUrl && <a href={`${appConst.albumOderUrl}${album.id}`} target="_blank" className="c2">
											<span className="pct pct-buy"/> {intl.formatMessage({ id: 'buttons.buy' })}
										</a>}
									</p>
								</div>
								<div className="item-list">
									<h2 className="t2 c2 mb20">{intl.formatMessage({ id: 'tracklist.title.track' })}</h2>
									<TrackList
										fields={fields}
										listContainerClassName="album-tracks-list"
										listClassName="track-list full-name no-cache no-more"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

TrackPage.propTypes = {
	id: PropTypes.string,
	getTrack: PropTypes.func,
	clearPlayqueue: PropTypes.func,
	title: PropTypes.string,
	album: PropTypes.shape({
		id: PropTypes.string,
		title: PropTypes.string,
		pochette: PropTypes.string
	}),
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	duree: PropTypes.number,
	isHiRes: PropTypes.bool,
	orderUrl: PropTypes.string,
	performer: PropTypes.object
}

TrackPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	title: selectors.getTitle(state),
	album: selectors.getAlbum(state),
	artist: selectors.getArtist(state),
	duree: selectors.getDuree(state),
	isHiRes: selectors.isHiRes(state),
	orderUrl: selectors.getOrderUrl(state),
	performer: selectors.getPerformer(state),
})

const actions = {
	getTrack: getTrackAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(TrackPage)



// WEBPACK FOOTER //
// ./src/pages/track/TrackPage.jsx